var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"overflow-hidden"},[_c('navbar'),_c('transition',{attrs:{"name":_vm.transitionName,"mode":"out-in"}},[_c('router-view',{staticClass:"animated"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }